import type { ReactNode } from "react";

interface PanelProps {
  title?: string;
  variant?: "default" | "err" | "ok" | "warn";
  padding?: "default" | "none" | "tight";
  className?: string;
  children?: ReactNode;
}

export function Panel({ title, variant = "default", padding = "default", className, children }: PanelProps) {
  const cls = [
    "panel",
    variant !== "default" && variant,
    padding === "none" && "panel--no-padding",
    padding === "tight" && "panel--tight",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <section className={cls}>
      {title && <h2>{title}</h2>}
      {children}
    </section>
  );
}
